var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReplayGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-3h24v24H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3F3F",
    fillRule: "nonzero",
    d: "M9.54 2.005C13.22 2.729 16 6 16 9.928 16 14.386 12.418 18 8 18s-8-3.614-8-8.072a8.09 8.09 0 0 1 1.118-4.119l2.114 1.362a5.557 5.557 0 0 0-.726 2.757c0 3.061 2.46 5.543 5.494 5.543s5.494-2.482 5.494-5.543A5.54 5.54 0 0 0 9.528 4.6L9.52 6.304 4.995 3.236 9.548.006 9.54 2.005z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplayGray);
export default __webpack_public_path__ + "static/media/icon-replay-gray.93294ea507852b3b677e7abd6b63b3e4.svg";
export { ForwardRef as ReactComponent };